import '@justinribeiro/lite-youtube';

// -----------------------------------------------------------------------------
// Plugin Includes
// -----------------------------------------------------------------------------

import Animate from '@plugins/animate';
// import extendJquery from '@plugins/extend-jquery';
import hubspotForm from '@plugins/hubspot-form';
import anchorSmoothScroll from '@plugins/anchor-smooth-scroll';
import loading from '@plugins/loading';
import externalLinks from '@plugins/external-links';
import formValidation from '@plugins/form-validation';
import jsLinkEvent from '@plugins/js-link-event';

// -----------------------------------------------------------------------------
// Component Includes
// -----------------------------------------------------------------------------
import archiveList from '@components/archive-list';
import modalVideo from '@components/modal-video';
import hamburgerMenu from '@components/hamburger-menu';
import siteHeader from '@components/site-header';
import siteHeaderSearch from '@components/site-header/site-header-search';
import socialShare from '@components/social-share';
import searchResults from '@components/search-results';
import banner from '@components/banner';
import industryNews from '@components/industry-news';
import glossary from '@components/glossary';
import productShot from '@components/product-shot';
import demoModal from '@components/demo-modal';

// -----------------------------------------------------------------------------
// Block Includes
// -----------------------------------------------------------------------------
import testimonialSlider from '@blocks/testimonial-slider';
import featuresSlider from '@blocks/features-slider';
// import textGrid from '@blocks/text-grid';
import roiCalculator from '@blocks/roi-calculator';
import caseStudies from '@blocks/case-studies';
import codeEmbed from '@blocks/code-embed';
import scrollingSections from '@blocks/scrolling-sections';
import faq from '@blocks/faq';
import featurePanels from '@blocks/feature-panels';
import steps from '@blocks/steps';

const initializer = {
  components: [
    // ['.text-grid-block', textGrid],
    ['.js-testimonial-slider', testimonialSlider],
    ['.js-features-slider', featuresSlider],
    ['.code-embed-block', codeEmbed],
    ['.archive-list', archiveList],
    ['.site-header', siteHeader],
    ['.site-header-search', siteHeaderSearch],
    ['.hamburger-menu', hamburgerMenu],
    ['.social-share', socialShare],
    ['.case-studies-block', caseStudies],
    ['html.frontend.search', searchResults],
    ['.js-banner', banner],
    ['#hubspot-form', hubspotForm],
    ['.roi-calculator-block', roiCalculator],
    ['.industry-news', industryNews],
    ['.js-video-modal-open', modalVideo],
    ['.scrolling-sections-block', scrollingSections],
    ['.glossary', glossary],
    ['.pb-shot', productShot],
    ['[data-demo], a[href*="storylane.io/"]', demoModal],
    ['.faq-block', faq],
    ['.feature-panels-block', featurePanels],
    ['.steps-block[data-layout="gantt"]', steps]
  ],
  plugins: [
    // extendJquery,
    loading,
    formValidation,
    externalLinks,
    anchorSmoothScroll,
    jsLinkEvent
  ]
};

class PackbackJS {
  constructor(initializer) {
    this.initializer = initializer;
    this.init();
  }

  init() {
    this.callAll(this.initializer.plugins);
    new Animate('[data-animation]');
    this.callAll(this.initializer.components, this.initComponent);
    this.bindLiteYoutubeState();

    // -----------------------------------------------------------------------------
    // Service Worker registration
    // -----------------------------------------------------------------------------
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', {
          scope: '/'
        });
      });
    }
  }

  callAll(items, fn = (fn) => fn()) {
    items.forEach(fn);
  }

  initComponent([selector, handler]) {
    const $component = $(selector);

    if (!$component.length) {
      return null;
    }

    return $component.each((i, item) => {
      return handler(item);
    });
  }

  bindLiteYoutubeState() {
    document.addEventListener('liteYoutubeIframeLoaded', (event) => {
      const target = event.target;
      if (target instanceof HTMLElement && target.matches('lite-youtube')) {
        target.setAttribute('data-activated', 'true');
      }
    });
  }
}

(($) => {
  // Document Ready
  $(() => {
    new PackbackJS(initializer);
  });
})($);
